// @internal
export function isArray(value) {
    return Array.isArray(value);
}
//# sourceMappingURL=isArray.js.map